export default __webpack_public_path__ + "static/media/parlamentia_sept_21.ba9375aa.png";